import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../atoms';
import { useRouter } from 'next/router';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveTab } from 'redux/actions/otherActions';

const item = [
  {
    id: 1,
    title: 'Tab 1',
    isVisible: false,
    content: 'Content 1',
  },
  {
    id: 2,
    title: 'Tab 2',
    isVisible: false,
    content: 'Content 2',
  },
  {
    id: 3,
    title: 'Tab 3',
    isVisible: false,
    content: 'Content 3',
  },
];

const TabHorizontal = (props) => {
  const dispatch = useDispatch();
  const { tabActive } = useSelector((state) => state.other);
  const { tabItem = item, isLink, className, isDivider = false, theme = 'blue-hedgehog', isCenter } = props;

  const router = useRouter();

  const [tab, setTab] = React.useState(tabItem);
  const [activeContent, setActiveContent] = React.useState();

  const onActive = (id, i) => {
    let _temp = [...tab];
    _temp.forEach((current) => {
      if (current.id === id) {
        current.isVisible = true;
        setActiveContent(current.content);
        dispatch(setActiveTab(i));
      } else {
        current.isVisible = false;
      }
    });

    setTab(_temp);
  };
  React.useEffect(() => {
    setTab(tabItem);
  }, [tabItem]);
  React.useEffect(() => {
    setActiveContent(tabItem[tabActive]?.content);
  }, []);

  return (
    <div className={`${className} w-full`}>
      <div className={`flex ${isCenter && 'justify-center'} ${isDivider ? 'border-b-2 border-blue-magnolia' : ''}`}>
        {isLink
          ? tab.map((item, i) => {
              return (
                <div
                  key={i}
                  className={`mr-3 ${
                    item?.link === router?.pathname || item?.parrent === router.pathname.split('/')[1]
                      ? 'border-b-2 border-blue-hedgehog'
                      : 'hover:border-b-2 hover:border-gray-silver'
                  }`}
                >
                  <Button
                    content={item?.contentType}
                    icon={item?.icon}
                    type="link"
                    link={item?.link}
                    variant="transparent"
                    theme={`${
                      item?.link === router?.pathname || item?.parrent === router.pathname.split('/')[1]
                        ? 'blue-hedgehog'
                        : 'gray-davys'
                    }`}
                    className="bold-text-2"
                  >
                    {item.title}
                  </Button>
                </div>
              );
            })
          : tab.map((item, i) => {
              return (
                <div key={i} className={`mr-3 ${i === tabActive ? `border-b-2 border-${theme}` : ''}`}>
                  <Button
                    action={() => onActive(item.id, i)}
                    variant="transparent"
                    theme={`${i === tabActive ? theme : 'gray-davys'}`}
                  >
                    {item.title}
                  </Button>
                </div>
              );
            })}
      </div>

      {!isLink && activeContent}
    </div>
  );
};

TabHorizontal.propTypes = {
  isLink: PropTypes.bool,
};

export default TabHorizontal;
